import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { apiURL } from "../api/index";

function Bookings(props) {
  const Navigate = useNavigate();
  const [loggedInUser, setLoggedInUser] = useState("");

  const [activeTab, setActiveTab] = useState("All");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const LoadPage = async () => {
      try {
        const res = await fetch(`${apiURL}/check`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        const data = await res.json();
        setLoggedInUser(data.name);
      } catch (error) {
        Navigate("/login");
      }
    };
    LoadPage();
    // filterByLoggedInUser();
  }, [Navigate]);

  // Filter bookings based on active tab
  const filteredBookings = props.bookings.filter((booking) => {
    if (activeTab === "All") return true && loggedInUser === booking.customer;
    if (activeTab === "Pending")
      return booking.status === "Pending" && loggedInUser === booking.customer;
    if (activeTab === "Completed")
      return (
        booking.status === "Completed" && loggedInUser === booking.customer
      );

    return false;
  });

  return (
    <div className="font-primary">
      <div className="mt-6 flex justify-between w-[88%] mx-auto items-center">
        <h2 className="text-2xl font-semibold text-primary">All Bookings</h2>
        <div className="flex">
          <button
            className={`flex-1 px-3 text-white m-1 py-2 rounded-full ${
              activeTab === "All" ? "bg-primary" : "bg-gray-300"
            }`}
            onClick={() => setActiveTab("All")}
          >
            ALL
          </button>
          <button
            className={`flex-1 px-3 m-1 py-2 text-white rounded-full ${
              activeTab === "Pending" ? "bg-red-600" : "bg-gray-300"
            }`}
            onClick={() => setActiveTab("Pending")}
          >
            Active
          </button>
          <button
            className={`flex-1 px-3 m-1 py-2 text-white rounded-full ${
              activeTab === "Completed" ? "bg-green-600" : "bg-gray-300"
            }`}
            onClick={() => setActiveTab("Completed")}
          >
            Success
          </button>
        </div>
      </div>
      {/* table of bookings including all, cancelled and success */}
      <div className="flex justify-between items-center text-gray-600">
        <div className="w-[88%] mx-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-background text-gray-800">
                <th className="py-2 px-4 font-semibold">Customer</th>
                <th className="py-2 px-4 font-semibold">Email</th>
                <th className="py-2 px-4 font-semibold">Price</th>
                <th className="py-2 px-4 font-semibold">Address</th>
                <th className="py-2 px-4 font-semibold">City</th>
                <th className="py-2 px-4 font-semibold">Status</th>
                <th className="py-2 px-4 font-semibold">Work</th>
              </tr>
            </thead>
            <tbody className="dark:bg-slate-500 dark:text-white">
              {filteredBookings.map((booking) => {
                return (
                  <tr className="text-center" key={booking._id}>
                    <td className="py-2 px-4">{booking.customer}</td>
                    <td className="py-2 px-4">{booking.email}</td>
                    <td className="py-2 px-4">{booking.total}</td>
                    <td className="py-2 px-4">{booking.address}</td>
                    <td className="py-2 px-4">{booking.city}</td>
                    <td>
                      <button className="cursor-default py-1 px-4 bg-gray-700 text-white rounded-sm">
                        Hired
                      </button>
                    </td>
                    <td>
                      {booking.status === "Completed" ? (
                        <button className="bg-green-500 px-2 py-1 text-white">
                          Completed
                        </button>
                      ) : (
                        <button className="bg-red-600 px-2 py-1 text-white">
                          Pending
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Bookings;
